import {
  trialBalanceThresholdColumnDefinition,
  functionalCurrencyColumnDefinition,
} from '../columnDefinitions';

export default [
  functionalCurrencyColumnDefinition,
  trialBalanceThresholdColumnDefinition,
];

